module.exports = __webpack_public_path__ + "img/cate1.9d5543d9.jpg";